import { Api, Auth } from '~/services';

import {
	getAllInterests as _getAllInterests,
	getInterestsFeed as _getInterestsFeed,
} from '../api/interests';

export function getAllInterests( ) {
	return ( dispatch, getStore ) => {

		return dispatch(async dispatch => {

				dispatch({
					type: 'REQUEST_ALL_INTERESTS'
				})

				const interests = await _getAllInterests();

                dispatch({
                    type: 'RECEIVE_ALL_INTERESTS',
                    interests
                })

		})
	}
}


export function getUserInterests( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_USER_INTERESTS'
				})

				Api.get( '/wp/user/interests', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_USER_INTERESTS',
						interests: data
					})
				})

			}
		)
	}
}


export function addInterestsToUser( interests ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !interests.length ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_USER_INTERESTS'
				})

				Api.post( '/wp/user/interests', {
					secure_token: Auth.getToken(),
					interests: interests
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_USER_INTERESTS',
						interests: data
					})
				})

			}
		)
	}
}


export function toggleInterests( interests ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !interests.length ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_USER_INTERESTS'
				})

				Api.post( '/wp/user/interests/toggle', {
					secure_token: Auth.getToken(),
					interests: interests
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_USER_INTERESTS',
						interests: data
					})
				})

			}
		)
	}
}


export function getInterestsFeed( interestSlug ) {
	return ( dispatch, getStore ) => {
		return dispatch(
			async dispatch => {

				dispatch({
					type: 'REQUEST_INTEREST_FEED'
				})

				const params = Auth.loggedIn() ? { secure_token: Auth.getToken() } : {};

				const data = await _getInterestsFeed(params, interestSlug);

                dispatch({
                    type: 'RECEIVE_INTEREST_FEED',
                    feed: data.feed,
                    interest: data.interest
                });
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/interests.js